import { createRouter, createWebHashHistory } from 'vue-router'
import loginPage from '@/views/loginPage'
import mainPage from '@/views/mainPage'
import homePage from '@/components/homePageComponent/homePage'
import INTPage from '@/components/homePageComponent/INTPage'
import readPage from '@/components/homePageComponent/readPage'
import ticketPage from '@/components/homePageComponent/ticketPage'
import reportLibrary from '@/components/homePageComponent/reportLibrary'
import favorPage from '@/components/homePageComponent/favorPage'
import personPage from '@/components/homePageComponent/personPage'
import articleDetail from '@/components/homePageComponent/articleDetail'
import keywordPage from '@/components/homePageComponent/keywordPage'
import catalogArticleDetail from '@/components/homePageComponent/catalogArticleDetail'
import manageUserPage from '@/components/homePageComponent/manageUserPage'
import commentPage from '@/components/homePageComponent/commentPage'
import mySubscribe from '@/components/mySubscribeComponent/mySubscribeDetail'
import exportReportPage from '@/components/homePageComponent/exportReportPage'

import KnowledgeDetail from '@/components/knowledgeComponent/KnowledgeDetail.vue'
import knowledgeManage from '@/components/knowledgeManageComponent/knowledgeManage.vue'
import knowledgeManageDetail from '@/components/knowledgeManageComponent/knowledgeManageDetail.vue'
import store from '@/store'
import { showManagerUserPage } from '@/untils/index'
import KnowledgeBase from '@/components/homePageComponent/KnowledgeBase.vue'
import AISearch from '@/components/homePageComponent/AISearch.vue'
import { showWebSearch } from '@/untils/company'

const routes = [
  {
    path: '/',
    name: 'loginPage',
    component: loginPage
  },
  {
    name: 'mainPage',
    component: mainPage,
    redirect: '/main',//页面默认加载的路由
    children: [
      {
        path: '/main',
        name: 'homePage',
        component: homePage,
        meta: {
          keepAlive: true // 需要缓存
        }
      },
      {
        path: '/INT',
        name: 'INT',
        component: INTPage,
        meta: {
          keepAlive: true // 需要缓存
        }
      },
      {
        path: '/reportLibrary',
        name: 'reportLibrary',
        component: reportLibrary,
      },
      {
        path: '/manageUserPage',
        name: 'manageUserPage',
        component: manageUserPage,
      },
      {
        path: '/favor',
        name: 'favorPage',
        component: favorPage,
        meta: {
          keepAlive: true // 需要缓存
        }
      },
      {
        path: '/articleDetail',
        name: 'articleDetail',
        component: articleDetail
      },
      {
        path: '/catalogArticleDetail',
        name: 'catalogArticleDetail',
        component: catalogArticleDetail,
        meta: {
          keepAlive: true // 需要缓存
        }
      },
      {
        path: '/read',
        name: 'readPage',
        component: readPage,
      },
      {
        path:'/mySubscribe',
        name: 'mySubscribe',
        component:mySubscribe,
        meta: {
          keepAlive: true // 需要缓存
        }
      },
      {
        path:'/AIKnowledgeBase',
        name: 'AIKnowledgeBase',
        component:KnowledgeBase
      },
      {
        path:'/AISearch',
        name: 'AISearch',
        component:AISearch
      },
      {
        path: '/person',
        name: 'personPage',
        component: personPage,
      },
      {
        path: '/ticket',
        name: 'ticket',
        component: ticketPage,
      },
      {
        path: '/keyword',
        name: 'keyword',
        component: keywordPage,
      },
      {
        path: '/exportReport',
        name: 'exportReportPage',
        component: exportReportPage,
      },
      {
        path: '/commentPage',
        name: 'commentPage',
        component: commentPage
      },
      {
        path: '/KnowledgeDetail',
        name: 'KnowledgeDetail',
        component: KnowledgeDetail
      },
      {
        path: '/knowledgeManage',
        name: 'knowledgeManage',
        component: knowledgeManage
      },
      {
        path: '/knowledgeManageDetail',
        name: 'knowledgeManageDetail',
        component: knowledgeManageDetail
      },
      
      
    
    ]
  }]
const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
})
const tokenqc = (to, from, next) => {
  console.log('opop')
  if (to.path == '/person') {
    if (store.getters.company && store.getters.company.companyType == 4 && (store.getters.company.vip == 4)) {
      next()
    }
    else {
      router.push({ path: "/main" })
    }
  }

  else if (to.path == '/manageUserPage') {

    if (store.getters.company && showManagerUserPage(store.getters.company.companyType) && store.getters.company.manager == 1) {
      next()
    }
    else {
      router.push({ path: "/main" })
    }
  }
  else if (to.path == '/keyword') {
    if (store.getters.company && store.getters.company.companyType == 4 && (store.getters.company.vip == 4 || store.getters.company.vip == 2)) {
      next()
    }
    else
      router.push({ path: "/main" })
  }
 
  else next()
}
const  isRouteInRoutes=(routes, targetPath)=> {
  return routes.some(route => {
   
    if (route.path === targetPath) {
      return true;
    }
    if (route.children) {
      return isRouteInRoutes(route.children, targetPath);
    }
    return false;
  });
}
router.beforeEach(async (to, from, next) => {
  console.log('beforeEach',to,router)
  const routes = router.options.routes;
  const isRouteExist = isRouteInRoutes(routes, to.path);
 console.log(isRouteExist)
 if(isRouteExist){
  if (localStorage.getItem('pctoken')) {
    console.log(store.getters.company, 'store.getters.company')
    if (store.getters.company == null) {



      await store.dispatch('toGetUserfor').then(() => {
        tokenqc(to, from, next)
      })




    }
    else {
      tokenqc(to, from, next)
    }



  }
  else {
    next()
  }
 }
 else {
  router.push({ path: "/main" })
 }
  

})
export default router
